<div style="background-color: #F5F7F8; height: 100vh; overflow-y: scroll; padding: 10px; padding-top: 20px; width: 100vw;">
    <img style="width: 22px; height: 22px; position: absolute; top: 25px; left: 20px;" (click)="this.back()" src="/assets/images/shared/back.svg">
    <h2 style="text-align: center;">Връщане на продукт</h2>
    <div style="height: 77vh; overflow-y: scroll; margin-bottom: 5px; width: 100%; overflow-x: hidden;">
        <div class="row" style="margin: auto; background-color: #E4F2FE; margin-top: 10px; border-radius: 10px; padding: 10px;">
            <div class="form-check col-1" style="display: grid; vertical-align: top; place-items: center;">
                <img style="width: 22px; height: 22px; margin-left: -10px;" src="/assets/images/vouchers/information.svg">
            </div>
            <p  class="col-10" style="top: 7px">
                Моля, след подаване на заявката за връщане, изпратете продуктите до посочения адрес.
            </p>
        </div>
        <div style="margin: auto; background-color: white; margin-top: 10px; border-radius: 10px; padding: 10px;">
            <h4 style="font-weight: bold;">Адрес за връщане на продукти</h4>
            <div class="row" style="margin-top: 12px;">
                <div class="col-6" style="text-align: left;">Фирма:</div>
                <div class="col-6" style="text-align: right;">{{ this.organisation?.data?.native_name + ' ' + this.organisation!.data.legal_form.label }}</div>
            </div>

            <div class="row" style="margin-top: 12px;">
                <div class="col-6" style="text-align: left;">Област:</div>
                <div class="col-6" style="text-align: right;">{{ this.organisation?.data?.return_address?.province || '-' }}</div>
            </div>

            <div class="row" style="margin-top: 12px;">
                <div class="col-6" style="text-align: left;">Населено място:</div>
                <div class="col-6" style="text-align: right;">{{ this.organisation?.data?.return_address?.city }}</div>
            </div>

            <div class="row" style="margin-top: 12px;">
                <div class="col-6" style="text-align: left;">Адрес:</div>
                <div class="col-6" style="text-align: right;">{{ this.streetInfo }}</div>
            </div>

            <div class="row" style="margin-top: 12px;">
                <div class="col-6" style="text-align: left;">Телефон за контакт:</div>
                <div class="col-6" style="text-align: right;">{{ this.organisation?.data?.return_address?.mobile_phone_1_e164 }}</div>
            </div>

            <div class="row" style="margin-top: 12px;">
                <div class="col-6" style="text-align: left;">Пояснения:</div>
                <div class="col-6" style="text-align: right;">{{ this.organisation?.data?.return_address?.description || '-' }}</div>
            </div>
        </div>
    </div>
    <div style="position: absolute; bottom: 25px; text-align: center; width: 90%; margin: auto; left: 5%;">
        <button type="button"  class="btn btn-primary" style="position: relative; bottom: 0px; width: 100%; margin: auto; height: 45px;" (click)="this.finishReturn()">Изпрати заявка за връщане</button>
    </div>
</div>
